import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import '../shared.css';

const UserEdit = () => {
  const { id } = useParams();
  const history = useHistory();
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage]     = useState('');

  const [formData, setFormData] = useState({
    FirstName: '',
    LastName: '',
    UserName: '',
    Email: '',
    ContactNumber: '',
  });

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, token, logout]);

  useEffect(() => {
    fetchData('UserApi', `/UserDetails/${id}`, token)
      .then(response => {
        if (response.responseCode === '1111') setFormData(response.response_data);
      })
      .catch(err => console.error('Error fetching User Details:', err));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      // Auto-update username when first/last name changes
      if (name === 'FirstName' || name === 'LastName') {
        const fn = name === 'FirstName' ? value : prev.FirstName;
        const ln = name === 'LastName'  ? value : prev.LastName;
        updated.UserName = `${fn.toLowerCase()}_${ln.toLowerCase()}`.slice(0, 15);
      }
      return updated;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!formData.FirstName)     { setErrorMessage('First Name is required!');     return; }
    if (!formData.LastName)      { setErrorMessage('Last Name is required!');      return; }
    if (!formData.ContactNumber) { setErrorMessage('Contact Number is required!'); return; }
    if (!formData.Email)         { setErrorMessage('Email is required!');          return; }

    const payload = { ...formData, UpdatedBy: userId };

    updateData('UserApi', `${id}`, payload, token)
      .then(() => {
        setSuccessMessage('User updated successfully!');
        setTimeout(() => history.push('/UserIndex'), 1000);
      })
      .catch(err => {
        console.error('Error updating record:', err);
        setErrorMessage('Failed to update user. Please try again.');
      });
  };

  return (
    <div className="pg-container">
      {/* ── Header ── */}
      <div className="pg-header">
        <h5 className="pg-title">User — Edit</h5>
        <div className="pg-action-row">
          <button className="pg-btn pg-btn-success" onClick={handleSubmit}>
            <DoneIcon /> Update
          </button>
          <Link to="/UserIndex" className="pg-btn pg-btn-danger">
            <CloseIcon /> Cancel
          </Link>
        </div>
      </div>

      {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
      {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

      {/* ── Form ── */}
      <div className="pg-card">
        <div className="pg-form-grid pg-form-grid-4">
          <div className="pg-field">
            <label className="pg-label">First Name <span className="req">*</span></label>
            <input className="pg-input" name="FirstName" value={formData.FirstName}
              onChange={handleChange} placeholder="Enter First Name" maxLength={30} />
          </div>

          <div className="pg-field">
            <label className="pg-label">Last Name <span className="req">*</span></label>
            <input className="pg-input" name="LastName" value={formData.LastName}
              onChange={handleChange} placeholder="Enter Last Name" maxLength={30} />
          </div>

          <div className="pg-field">
            <label className="pg-label">User Name</label>
            <input className="pg-input" name="UserName" value={formData.UserName}
              readOnly placeholder="Auto-generated" />
          </div>

          <div className="pg-field">
            <label className="pg-label">Contact Number <span className="req">*</span></label>
            <input className="pg-input" name="ContactNumber" value={formData.ContactNumber}
              onChange={handleChange} placeholder="Enter Contact Number" maxLength={15} />
          </div>

          <div className="pg-field">
            <label className="pg-label">Email <span className="req">*</span></label>
            <input className="pg-input" name="Email" value={formData.Email}
              onChange={handleChange} placeholder="Enter Email" maxLength={40} />
          </div>
        </div>
      </div>

      <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
    </div>
  );
};

export default UserEdit;
